var _globalThis_expo_modules;
var _globalThis_expo;
var HeadModule = null;
if (typeof expo !== "undefined" && ((_globalThis_expo = globalThis.expo) === null || _globalThis_expo === void 0 ? void 0 : (_globalThis_expo_modules = _globalThis_expo.modules) === null || _globalThis_expo_modules === void 0 ? void 0 : _globalThis_expo_modules.ExpoGo)) {
  var _globalThis_expo_modules1, _globalThis_expo1;
  HeadModule = (_globalThis_expo1 = globalThis.expo) === null || _globalThis_expo1 === void 0 ? void 0 : (_globalThis_expo_modules1 = _globalThis_expo1.modules) === null || _globalThis_expo_modules1 === void 0 ? void 0 : _globalThis_expo_modules1.HeadModule;
}
export {
  HeadModule
};
//# sourceMappingURL=HeadModule.js.map
